// extracted by mini-css-extract-plugin
export default {"tagsWrapper":"EmployeeCard_tagsWrapper__2BygV"};